import React from 'react'

import Accordion from '../../../components/Accordion'
import { supportProgramTypes } from '../../../constants/support-programs'

import ChevronUpIconBlue from '../../../assets/icons/chevron-up.png'
import ChevronDownIconBlue from '../../../assets/icons/chevron-down.png'

const Faqs = () => {
  const supportProgram = supportProgramTypes['liver-forever-program']
  return (
    <div className="mt-[3.75rem] pb-[60px]">
      <div className="text-[32px] px-[41px] text-[#1F2933] font-[600] leading-[42px]">
        FAQs
      </div>
      <div className="mt-[44px] px-[31px]">
        {supportProgram?.faqs?.length > 0 &&
          supportProgram?.faqs?.map((question, index) => (
            <Accordion
              title={question.question}
              answer={question.answer}
              index={index}
              upIcon={ChevronUpIconBlue}
              downIcon={ChevronDownIconBlue}
              styles={{
                bg: '#F2F4F7',
                titleColor: '#101828',
                answerColor: '#667085',
              }}
            />
          ))}
      </div>
    </div>
  )
}

export default Faqs
